export default __webpack_public_path__ + "static/media/bowl.6222410f.png";